import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppComponent } from '@app/app.component';

@Component({
  selector: 'dgx-root',
  template: `
    <ng-content></ng-content>
    <div class="center-item grid">
      <header class="app-header js-app-header"></header>
      <div class="grid__col-12 grid__col--bleed">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MsTeamsBootstrapComponent extends AppComponent {}
